// @flow

import React, { Component } from 'react'
import { Breakpoint } from 'react-socks'
import { Container, Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withTranslation, Trans } from 'react-i18next'
import Lottie from 'react-lottie'
import Swal from 'sweetalert2'
import differenceInHours from 'date-fns/differenceInHours';
import * as animationData from '../assets/loading.json'
import * as animationData404 from '../assets/404.json'
import '../styles/RestaurantTable.scss'
import { updateRestoInfo, updateType, resetCart, applyDiscount, applyCoupon, pickedOrderType, updateTable, updateQrId, initSharedSession, syncSharedCart, updateCartTotal, leaveSharedSession } from '../actions/cartAction';
import { updateRestoSettings, updateDeliverySchedule, updateOrderSchedule, updateDeliverySettings, updateTakeawaySettings, updateMenuSettings, setLanguage } from '../actions/settingsAction';

import CartTable from './CartTable'
import ProductDetail from './ProductDetail'
import ProductCartRow from './ProductCartRow'
import LanguageSelector from './LanguageSelector'
import $ from "jquery"

import { parseSchedule, computeDiscount, convertFirebaseUrlToCustomDomain, formatCurrency } from './Utils'
import { CartType, ProductType } from '../flowObjectType'
import { firestore, analytics } from '../services/firebase'
import dayjs from 'dayjs'
import { getAvailabilityPeriod, isProductAvailable } from '../utils/availabilityUtils'
import { isPublicHolidayToday } from '../utils/publicHolidays'
import { getSecondaryFirestore } from '../services/firebaseSecondary'
import sharedCartService from '../services/sharedCartService'
import { getTrans, getActiveLanguages, DEFAULT_LANG } from '../utils/translations'

import spicy1 from "../assets/classification/spicy1.webp"
import spicy2 from "../assets/classification/spicy2.webp"
import spicy3 from "../assets/classification/spicy3.webp"
import homemade from "../assets/classification/homemade.webp"
import vegetarian from "../assets/classification/vegetarian.png"
import recommended from "../assets/classification/recommended.png"
import halal from "../assets/classification/halal.webp"

const ImageData = {}
ImageData['vegetarian'] = vegetarian
ImageData['recommended'] = recommended
ImageData['halal'] = halal
ImageData['homemade'] = homemade
ImageData['spicy1'] = spicy1
ImageData['spicy2'] = spicy2
ImageData['spicy3'] = spicy3

// color
// text black
// background #F1F1F1
// blue #00CCBB
// yellow #FDC151
// red #FF4B4B

type Props = {
  match: Object,
  cart: CartType,
  settings: Object,
  updateType: Function,
  updateRestoInfo: Function,
  updateRestoSettings: Function,
  updateDeliverySchedule: Function,
  updateOrderSchedule: Function,
  resetCart: Function,
  updateTakeawaySettings: Function,
  updateDeliverySettings: Function,
  updateTable: Function,
  updateQrId: Function,
  initSharedSession: Function,
  syncSharedCart: Function,
  updateCartTotal: Function,
  leaveSharedSession: Function,
  setLanguage: Function,
  t: Function,
}

type State = {
  canOrder: boolean,
  sharedCart: boolean,
  settings: Object,
  informations: Object,
  showProductDetail: boolean,
  restaurant: Object,
  sections: Array<Object>,
  selectedProduct: ?ProductType,
  invalidQrCode: boolean,
  selectedCategoryIdx: number,
  selectedIdx: ?number,
  orderType: ?number,
  table: ?string,
  showCart: boolean
}

function goToAnchor(event: Object, id: string) {
  const productPositionY = $(`#section-${id}`).offset().top - 65
  // $(event.target).css('backgroundColor', 'white')
  $("html, body").animate({ scrollTop: productPositionY }, 500);
  event.preventDefault();
}

let savedSticky = 0
function handleStickyHeader(header) {
  let sticky = header[0].offsetTop
  if (header.hasClass("sticky")) {
    sticky = savedSticky
  }

  if (window.pageYOffset > sticky) {
    savedSticky = sticky
    header.addClass("sticky");
  } else {
    header.removeClass("sticky");
  }
}
function handleActiveSection(header) {

  const topMenuHeight = header.outerHeight() + 10
  const menuItems = header.find(".options-btn")
  const scrollItems = menuItems.map(function () {
    var item = $($(this).attr("href"));
    if (item.length) { return item; }
    return null
  });

  var fromTop = window.scrollY + topMenuHeight;
  var lastId;
  // Get id of current scroll item

  var cur = scrollItems.map(function () {
    if ($(this).offset().top < fromTop)
      return this;
    return null
  });
  // Get the id of the current element
  cur = cur[cur.length - 1];
  var id = cur && cur.length ? cur[0].id : "";

  if (lastId !== id) {
    lastId = id;
    // Set/remove active class
    if (id === "") return
    menuItems.removeClass("selected")
    const selectedItem = menuItems.filter("[href='#" + id + "']")
    selectedItem.addClass("selected");
    if (selectedItem[0]) {
      selectedItem[0].scrollIntoView({
        behavior: 'instant',
      });
    }
  }

}

const CategoryRow = (props) => props.category.displayApp === false ?
  (<></>)
  : (
    <>
      <a href={`#section-${props.category.id}`} className={`options-btn ${props.selected ? 'selected' : ''}`} onClick={(event) => { goToAnchor(event, props.category.id) }}>
        {getTrans(props.category, 'name', props.lang)}
      </a>
    </>
  )

const Section = (props) => (
  <div>
    <h3 className="section" id={`section-${props.id}`}>
      <div className="section-title">{props.title.toUpperCase()}</div>
    </h3>
    {props.description && (
      <div className="section-description">
        {props.description}
      </div>
    )}
  </div>
)

const NoImageSVG = ({ t }) => (
  <div className="relative w-full h-32 bg-gray-100 flex items-center justify-center">
    <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
    <span className="absolute bottom-2 text-xs text-gray-500">{t('restaurant.photoSoon')}</span>
  </div>
)

const ClassificationImages = ({ classification }) => {
  return (
    <div className="flex flex-row gap-1 my-1">
      {classification && (classification.spicyLevel > 0 ?? false) && (
        <img
          key={'spicy'}
          alt="produit"
          className="w-6 h-6"
          src={ImageData[`spicy${classification.spicyLevel}`]}
        />
      )}
      {classification && (classification.isVegetarian ?? false) && (
        <img
          key={'vegetarian'}
          alt="produit"
          className="w-6 h-6"
          src={ImageData['vegetarian']}
        />
      )}
      {classification && (classification.isRecommended ?? false) && (
        <img
          key={'recommended'}
          alt="produit"
          className="w-6 h-6"
          src={ImageData[`recommended`]}
        />
      )}
      {classification && (classification.isHomemade ?? false) && (
        <img
          key={'homemade'}
          alt="produit"
          className="w-6 h-6"
          src={ImageData[`homemade`]}
        />
      )}
      {classification && (classification.isHalal ?? false) && (
        <img
          key={'halal'}
          alt="produit"
          className="w-6 h-6"
          src={ImageData[`halal`]}
        />
      )}
    </div>
  );
};

const ProductRow = (props) => {
  const { product, orderType, settings, t } = props
  const cartProducts = props.cartProducts ? props.cartProducts.filter(e => e.id === product.id) : [];
  const totalQuantity = cartProducts.length > 0 ? cartProducts.reduce((total, p) => total + p.quantity, 0) : 0;
  const price = formatCurrency(product.unitPrice, settings.currencySymbol)
  const unitPrice = parseFloat(product.unitPrice);

  let discountPrice = 0;
  let hasDiscount = false;
  let discountLabel = '';

  if (orderType === 1 && product.takeawayDiscount && product.takeawayDiscount.discount) {
    discountPrice = unitPrice * (1 - product.takeawayDiscount.discount / 100)
    hasDiscount = true;
    discountLabel = product.takeawayDiscount.discount
  }
  else if (orderType === 4 && product.deliveryDiscount && product.deliveryDiscount.discount) {
    discountPrice = unitPrice * (1 - product.deliveryDiscount.discount / 100)
    hasDiscount = true;
    discountLabel = product.deliveryDiscount.discount
  }
  else if ((orderType === 2 || orderType === 3) && product.tableDiscount && product.tableDiscount.discount) {
    discountPrice = unitPrice * (1 - product.tableDiscount.discount / 100)
    hasDiscount = true;
    discountLabel = product.tableDiscount.discount
  }

  return (
    <div
      className={`relative w-40 sm:w-40 md:w-44 lg:w-48 xl:w-52 h-64 sm:h-68 md:h-72 lg:h-76 xl:h-80 bg-white rounded-lg border border-gray-200 overflow-hidden cursor-pointer transition-all duration-200 hover:border-blue-500 hover:shadow-md ${cartProducts.length > 0 ? 'ring-2 ring-blue-500 border-blue-500' : ''}`}
      onClick={props.toggleModal(product)}
    >
      {/* Product Image */}
      {product.image.path !== '' ? (
        <div className="relative w-full h-32">
          <img
            className="w-full h-full object-cover"
            src={convertFirebaseUrlToCustomDomain(product.image.path, props.cdnDomain)}
            alt={getTrans(product, 'name', props.lang)}
          />
          {/* Classification logos positioned on image */}
          {product.classification && (
            <div className="absolute bottom-2 left-2">
              <ClassificationImages classification={product.classification} />
            </div>
          )}
        </div>
      ) : (
        <div className="relative w-full h-32">
          <NoImageSVG t={t} />
          {/* Classification logos positioned on placeholder */}
          {product.classification && (
            <div className="absolute bottom-2 left-2">
              <ClassificationImages classification={product.classification} />
            </div>
          )}
        </div>
      )}

      {/* Product Content */}
      <div className="p-2 flex flex-col gap-1 flex-1">
        {/* Product Name */}
        <h3 className="font-semibold text-base text-gray-900 leading-tight line-clamp-2">
          {getTrans(product, 'name', props.lang)}
        </h3>

        {/* Product Description */}
        {product.description !== "" && (
          <p className="text-gray-600 leading-[1.2] text-sm line-clamp-2">
            {getTrans(product, 'description', props.lang)}
          </p>
        )}
      </div>

      {/* Product Price - Absolutely Positioned */}
      <div className="absolute bottom-2 left-0 right-0 flex justify-center px-2">
        <div
          className="inline-block px-2 py-1 rounded-full"
          style={{
            backgroundColor: settings?.color ? `${settings.color}1A` : 'rgba(59, 130, 246, 0.1)'
          }}
        >
        {hasDiscount && (
          <div className={`${!product.canOrder ? 'text-red-500' : 'text-gray-900'}`}>
            <span className="line-through text-gray-500 text-sm">{formatCurrency(unitPrice, settings.currencySymbol)}</span>
            <span className="ml-1 font-semibold text-sm">{t('restaurant.discountPrice', { discount: discountLabel, price: formatCurrency(discountPrice, settings.currencySymbol) })}</span>
            {!product.canOrder && (
              <span className="block text-red-500 text-xs">{t('common.unavailable')}</span>
            )}
          </div>
        )}
        {!hasDiscount && product.unitPrice > 0 && (
          <div className={`font-semibold text-base ${!product.canOrder ? 'text-red-500' : 'text-gray-900'}`}>
            {price}
            {!product.canOrder && (
              <span className="block text-red-500 text-xs">{t('common.unavailable')}</span>
            )}
          </div>
        )}
        </div>
      </div>

      {/* Quantity Badge */}
      {cartProducts.length > 0 && (
        <div className="absolute top-2 right-2 bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-semibold">
          {totalQuantity}
        </div>
      )}
    </div>
  )
}

class RestaurantTable extends Component<Props, State> {
  unsubscribe: Object
  unsubscribeProduct: Object
  unsubscribeCategory: Object
  refRestaurant: Object
  refProduct: Object
  refCategory: Object
  refDiscount: Object
  refOption: Object
  refRecommendation: Object
  readOnly: boolean
  products: Array<Object>
  categories: Array<Object>
  discounts: Array<Object>
  options: Array<Object>
  recommendations: Array<Object>
  selectCategory: Function
  pendingSharedCartInit: ?Object

  constructor(props: Object) {
    super(props);

    this.unsubscribe = null
    this.unsubscribeProduct = null
    this.unsubscribeCategory = null
    this.refRestaurant = null
    this.refProduct = null
    this.refCategory = null
    this.refDiscount = null
    this.refOption = null

    this.readOnly = false
    this.allProducts = []
    this.availabilityTimer = null
    this.availabilityHours = null
    this._lastAvailabilityKey = null
    this.products = []
    this.categories = []
    this.discounts = []
    this.options = []
    this.pendingSharedCartInit = null  // Store QR parameters for delayed shared cart initialization
    this.restoUpdateTimeout = null  // Store setTimeout reference for cleanup
    this._isMounted = false  // Track component mount state

    this.state = {
      canOrder: false,
      sharedCart: false,  // Default false for backward compatibility
      settings: null,
      informations: null,
      showProductDetail: false,
      restaurant: null,
      sections: [],
      selectedProduct: null,
      invalidQrCode: false,
      tableDisabled: false,
      selectedCategoryIdx: 0,
      selectedIdx: undefined,
      orderType: undefined,
      table: null,
      showCart: false,
    }
  }

  componentDidMount() {
    this._isMounted = true
    const id = this.props.match.params.id

    // Check if QR code ID has changed from what's stored in Redux
    if (id && id.length === 41) {
      // If we have a different QR code than what's in the cart, reset immediately
      if (this.props.cart.qrId && this.props.cart.qrId !== id.split('-')[1]) {
        this.props.resetCart();
        this.props.updateTable(''); // Clear table immediately
        this.props.updateQrId(null);
      }

      // Also check time-based cart expiration
      const cartCreatedAt = new Date(this.props.cart.createdAt);
      if (this.props.cart.flushCart === true || isNaN(cartCreatedAt) || differenceInHours(new Date(), cartCreatedAt) >= 10) {
        this.props.resetCart();
      }

      this.handleTableQr(id)
    }
  }

  handleTableQr = async (barcode) => {
    const restoId = barcode.split('-')[0]
    const tableId = barcode.split('-')[1]

    // Clear any previous table data immediately
    this.setState({
      table: null, // Clear table display while loading
      orderType: 3
    })

    const ref = firestore().collection(`Restaurant/${restoId}/QRCode`).doc(tableId)

    try {
      const doc = await ref.get()
      if (!doc.exists) {
        // Clear any stale cart data if QR code is invalid
        this.props.resetCart()
        this.props.updateTable('')
        this.props.updateQrId(null)

        setTimeout(() => {
          this.setState({ invalidQrCode: true })
        }, 200)
        return false
      }

      const qrcode = doc.data()

      // Fetch restaurant doc to check for externalSource
      const restoDoc = await firestore().collection('Restaurant').doc(restoId).get()
      const resto = restoDoc.exists ? { id: restoDoc.id, ...restoDoc.data() } : null

      // Initialize restaurant data
      await this.initRestaurant(restoId, resto)
      this.props.updateType(3)
      this.props.updateTable(qrcode.table)
      this.props.updateQrId(doc.id)

      // Store QR parameters for shared cart initialization after restaurant settings are loaded
      this.pendingSharedCartInit = { restoId, tableId, qrId: doc.id }

      this.setState({
        table: qrcode.table,
        orderType: 3
      })

      return true
    } catch (err) {
      console.log(err)
      // Clear any stale cart data on error
      this.props.resetCart()
      this.props.updateTable('')
      this.props.updateQrId(null)

      this.setState({ invalidQrCode: true })
      return false
    }
  }

  componentWillUnmount() {
    this._isMounted = false
    if (this.availabilityTimer) clearInterval(this.availabilityTimer)

    // Clear pending setTimeout to prevent orphaned listener initialization
    if (this.restoUpdateTimeout) {
      clearTimeout(this.restoUpdateTimeout)
      this.restoUpdateTimeout = null
    }

    // Unsubscribe from ALL Firestore listeners
    if (this.unsubscribe) this.unsubscribe()
    if (this.unsubscribeProduct) this.unsubscribeProduct()
    if (this.unsubscribeCategory) this.unsubscribeCategory()

    // Clean up shared cart service
    if (sharedCartService.isInSharedMode()) {
      sharedCartService.leaveSession()
    }
  }

  initializeSharedCart = async (restoId, tableId, qrId) => {
    try {
      const sessionId = await sharedCartService.initializeSession(restoId, tableId, qrId, {
        onCartUpdate: this.handleSharedCartUpdate,
        onSessionStateChange: this.handleSessionStateChange,
        onError: this.handleSharedCartError,
        onDocumentDeleted: this.handleDocumentDeleted
      })

      this.props.initSharedSession(sessionId, sharedCartService.getCurrentSession())

      // Initialize cart data from Firebase
      const currentCart = sharedCartService.getCurrentCart()
      if (currentCart) {
        this.props.syncSharedCart(currentCart)
        // Recalculate totals immediately (no forceUpdate to prevent loops)
        this.recalculateCartTotals(currentCart)
      }

    } catch (error) {
      console.error('Failed to initialize shared cart:', error)
      // Fall back to regular cart mode
    }
  }


  handleSharedCartUpdate = async (cartData, sessionState) => {
    // If session is completed, ensure we clear the cart
    if (sessionState === 'completed') {
      this.props.resetCart(true) // Clear qrId in shared mode - Firebase will restore it
      // Don't process cart data for completed sessions
      return
    }

    // Normal cart sync for active sessions only
    // Immediately update Redux store with synced cart data from Firebase
    this.props.syncSharedCart(cartData)

    // Recalculate totals immediately (no setTimeout delay, no forceUpdate to prevent loops)
    this.recalculateCartTotals(cartData)
  }

  recalculateCartTotals = (cartData) => {
    if (!cartData.products || cartData.products.length === 0) {
      this.props.updateCartTotal(0, 0, 0, 0, 0)
      return
    }

    let cartTotal = 0
    let cartTotalHT = 0
    let cartTotalVat = 0
    let cartTotalProducts = 0
    let cartSubtotal = 0

    cartData.products.forEach((product) => {
      const { total, totalHT, totalVat, subtotal } = this.getProductPrice(product, product.quantity, true, false)
      cartTotal += total
      cartTotalHT += totalHT
      cartTotalVat += totalVat
      cartTotalProducts += product.quantity
      cartSubtotal += subtotal
    })

    // Only update Redux state - DO NOT sync back to Firebase to avoid infinite loop
    this.props.updateCartTotal(cartTotal, cartTotalHT, cartTotalVat, cartTotalProducts, cartSubtotal)
  }

  getProductPrice = (product, quantity, forTotal, applyDiscount) => {
    const rubric = product.rubric
    const orderType = this.props.cart.orderType || 3

    if (typeof product === 'undefined') return { total: 0, totalHT: 0, totalVat: 0, subtotal: 0 }
    let total = quantity * product.unitPrice
    let totalHT = quantity * product.unitPriceHT

    if (forTotal) {
      rubric?.forEach((section) => {
        section.data.forEach((rubric) => {
          if (rubric.checked && rubric.unitPrice > 0) {
            if (section.allowSameMultiple) {
              total += quantity * rubric.unitPrice * (rubric.quantity || 1)
              totalHT += quantity * rubric.unitPriceHT * (rubric.quantity || 1)
            }
            else {
              total += quantity * rubric.unitPrice
              totalHT += quantity * rubric.unitPriceHT
            }
          }
        })
      })
    }

    // Apply product discount
    if (orderType === 1 && product.takeawayDiscount && product.takeawayDiscount.discount) {
      total = total * (1 - product.takeawayDiscount.discount / 100)
      totalHT = totalHT * (1 - product.takeawayDiscount.discount / 100)
    }
    else if (orderType === 4 && product.deliveryDiscount && product.deliveryDiscount.discount) {
      total = total * (1 - product.deliveryDiscount.discount / 100)
      totalHT = totalHT * (1 - product.deliveryDiscount.discount / 100)
    }
    else if ((orderType === 2 || orderType === 3) && product.tableDiscount && product.tableDiscount.discount) {
      total = total * (1 - product.tableDiscount.discount / 100)
      totalHT = totalHT * (1 - product.tableDiscount.discount / 100)
    }

    let subtotal = total

    // Apply cart discount (simplified for shared cart)
    if (this.props.cart.discount && applyDiscount) {
      if (
        (orderType === 1 && (!product.takeawayDiscount || (product.takeawayDiscount && product.takeawayDiscount.canDiscount))) ||
        (orderType === 4 && (!product.deliveryDiscount || (product.deliveryDiscount && product.deliveryDiscount.canDiscount))) ||
        ((orderType === 2 || orderType === 3) && (!product.tableDiscount || (product.tableDiscount && product.tableDiscount.canDiscount)))
      ) {
        total = total * (1 - this.props.cart.discount / 100)
        totalHT = totalHT * (1 - this.props.cart.discount / 100)
      }
    }

    let totalVat = total - totalHT
    return { total, totalHT, totalVat, subtotal }
  }


  handleSessionStateChange = (sessionState) => {
    // Handle session state changes (locked, completed, active, etc.)
    if (sessionState === 'locked') {
      // Show notification that cart is locked for checkout
      // Show user-friendly notification
      Swal.fire({
        icon: 'info',
        title: this.props.t('sharedCart.lockedTitle'),
        text: this.props.t('sharedCart.lockedText'),
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true
      });
    } else if (sessionState === 'completed') {
      // Reset local cart and reset shared session
      this.resetCartAfterOrderCompletion()
    } else if (sessionState === 'active') {
      // Show notification that cart is available again
      Swal.fire({
        icon: 'success',
        title: this.props.t('sharedCart.availableTitle'),
        text: this.props.t('sharedCart.availableText'),
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
      });

      // Session was reset, ensure we're ready for new products
      // No action needed - Firebase sync will handle cart data
    }
  }

  resetCartAfterOrderCompletion = async () => {
    try {
      // Reset the shared session instead of leaving completely
      await sharedCartService.resetSession()

      // Reset local Redux cart state (clear qrId in shared mode - Firebase will restore it)
      this.props.resetCart(true)

      // Stay in shared mode but with reset session
      // Don't call leaveSharedSession() - keep users connected

      // Show success notification using SweetAlert
      // Note: Using setTimeout to ensure state updates complete first
      setTimeout(() => {
        Swal.fire({
          title: this.props.t('sharedCart.completedTitle'),
          text: this.props.t('sharedCart.completedText'),
          icon: 'success',
          timer: 4000,
          showConfirmButton: false
        })
      }, 500)

    } catch (error) {
      console.error('❌ Error during cart reset after order completion:', error)

      // If session reset fails, fall back to leaving session
      try {
        await sharedCartService.leaveSession()
        this.props.leaveSharedSession()
      } catch (fallbackError) {
        console.error('❌ Fallback session leave also failed:', fallbackError)
      }
    }
  }

  handleSharedCartError = (error) => {
    console.error('Shared cart error:', error)
    // Optionally fall back to regular cart mode
  }

  handleDocumentDeleted = () => {
    // Reset Redux cart to match the new empty session
    this.props.resetCart()

    // Get the new session's cart data from the service
    const currentCart = sharedCartService.getCurrentCart()
    if (currentCart) {
      this.props.syncSharedCart(currentCart)
    }

    // Show user notification
    Swal.fire({
      title: this.props.t('sharedCart.resetTitle'),
      text: this.props.t('sharedCart.resetText'),
      icon: 'info',
      timer: 4000,
      showConfirmButton: false,
      toast: true,
      position: 'top-end'
    })
  }

  loadScript = () => {
    const header = $("#sticky-header");
    if (header.length) {
      window.onscroll = () => {
        handleActiveSection(header)
        handleStickyHeader(header)
      }
    }
  }

  initRestaurant = async (restoId, resto) => {
    // Determine if menu data should come from a secondary Firebase project
    let menuFirestore = firestore()
    let menuRestoId = restoId
    this.cdnDomain = null // null means use default CDN

    if (resto?.settings?.externalSource) {
      try {
        const secondaryFs = getSecondaryFirestore()
        const extDocs = await secondaryFs
          .collection('Restaurant')
          .where('urlName', '==', resto.settings.externalSource)
          .get()

        if (!extDocs.empty) {
          menuFirestore = secondaryFs
          menuRestoId = extDocs.docs[0].id
          this.cdnDomain = 'https://cdn2.we-eats.com'
        } else {
          console.warn(`externalSource "${resto.settings.externalSource}" not found in secondary project, falling back to primary`)
        }
      } catch (err) {
        console.warn('Failed to initialize secondary Firebase, falling back to primary:', err)
      }
    }

    // Settings, discounts always from primary
    this.refRestaurant = firestore().collection('Restaurant').doc(restoId)
    this.refDiscount = firestore().collection(`Restaurant/${restoId}/Discount`)

    // Menu data (products, categories, options, recommendations) from resolved source
    this.refProduct = menuFirestore.collection(`Restaurant/${menuRestoId}/Product`)
    this.refOption = menuFirestore.collection(`Restaurant/${menuRestoId}/Rubric`)
    this.refCategory = menuFirestore.collection(`Restaurant/${menuRestoId}/Category`).where('status', '==', 1)
    this.refRecommendation = menuFirestore.collection(`Restaurant/${menuRestoId}/Recommendation`)

    this.unsubscribe = this.refRestaurant.onSnapshot(this.onRestoUpdate)
    this.unsubscribeProduct = this.refProduct.onSnapshot(this.onProductUpdate)
    this.unsubscribeCategory = this.refCategory.onSnapshot(this.onCategoryUpdate)

    // Re-check product availability every 60 seconds for time-based filtering.
    // checkProductWithAvailability short-circuits when no day/period boundary has been crossed.
    this.availabilityTimer = setInterval(this.checkProductWithAvailability, 60000)

    const productP = this.refProduct.get()
    const categoryP = this.refCategory.get()
    const discountP = this.refDiscount.get()
    const optionP = this.refOption.get()
    const recoP = this.refRecommendation.get()

    Promise.all([productP, categoryP, discountP, optionP])
      .then(([product, category, discount, option]) => {
        const products = []
        const categories = []
        const discounts = []
        const options = []
        const recos = []

        const allProducts = []
        product.forEach((doc) => {
          const { createdAt, ...data } = doc.data()
          allProducts.push({ id: doc.id, ...data })
        });
        this.allProducts = allProducts
        products.push(...this.filterProducts(allProducts))
        category.forEach((doc) => {
          const { createdAt, ...data } = doc.data()
          if (!data.internal && (data.displayApp || data.displayApp === undefined)) categories.push({ id: doc.id, ...data })
        });
        discount.forEach((doc) => {
          const { createdAt, ...data } = doc.data()
          discounts.push({ id: doc.id, ...data })
        });
        option.forEach((doc) => {
          const { id, products, shared, ...data } = doc.data()
          options.push({ id: doc.id, ...data })
        })
        this.products = products
        this.categories = categories.sort((a, b) => (a.index < b.index ? -1 : 1))
        this.discounts = discounts
        this.options = options
        this.recommendations = recos
        this.getSections()
        return true
      })
      .catch(err => {
        console.log(err)
        return false
      })
  }

  onRestoUpdate = (querySnapshot: Object) => {
    const restaurant = querySnapshot.data()
    const orderSchedule = parseSchedule(restaurant.settings.orderSchedule);
    const deliverySchedule = parseSchedule(restaurant.settings.deliverySchedule);
    const deliverySettings = restaurant.deliverySettings || {};
    const takeawaySettings = restaurant.takeawaySettings || {};

    if (!restaurant.settings.table) {
      this.setState({ invalidQrCode: true, tableDisabled: true })
      return
    }

    this.props.updateRestoInfo(restaurant.informations.id, restaurant.informations.name, restaurant.informations.postalCode, restaurant.state.canOrderTable ?? true, restaurant.informations);
    this.props.updateRestoSettings(restaurant.informations.id, restaurant.settings.color, restaurant.settings.autoAcceptOrder, restaurant.settings.delivery, restaurant.settings.takeaway, restaurant.settings.table, restaurant.settings.stripe || '', restaurant.settings.orderTypePopup || false, restaurant.settings.sharedCart ?? false, restaurant.settings.currencySymbol || '€', restaurant.settings.showCurrencyOnOrder !== false);
    this.props.updateMenuSettings({ productComments: restaurant.settings.productComments, languages: restaurant.settings.languages });
    // Langue choisie non activée par le restaurant : retour au français
    if (!getActiveLanguages(restaurant.settings).includes(this.props.settings.lang)) {
      this.props.setLanguage(DEFAULT_LANG)
    }
    this.props.updateDeliverySchedule(deliverySchedule);
    this.props.updateOrderSchedule(orderSchedule);
    this.props.updateDeliverySettings(deliverySettings);
    this.props.updateTakeawaySettings(takeawaySettings);
    this.availabilityHours = restaurant.settings?.availabilityHours ?? null
    this._lastAvailabilityKey = null
    this.checkProductWithAvailability()

    if (!restaurant.settings.delivery && !restaurant.settings.takeaway && !restaurant.settings.table) {
      this.readOnly = true
    }


    analytics().logEvent('home_page', { restoId: restaurant.informations.id, restoName: restaurant.informations.name });


    this.restoUpdateTimeout = setTimeout(() => {
      // Guard against unmounted component
      if (!this._isMounted) return

      this.setState({
        settings: restaurant.settings,
        informations: restaurant.informations,
        restaurant: restaurant,
        canOrder: restaurant.state.canOrderTable ?? true,
        sharedCart: restaurant.settings.sharedCart ?? false  // Default false for backward compatibility
      })
      // Initialize shared cart if there's a pending initialization and shared cart is enabled
      if (this.pendingSharedCartInit && (restaurant.settings.sharedCart ?? false)) {
        const pendingInit = this.pendingSharedCartInit
        if (pendingInit) {
          const { restoId, tableId, qrId } = pendingInit
          this.initializeSharedCart(restoId, tableId, qrId)
        }
        this.pendingSharedCartInit = null  // Clear pending initialization
      } else if (this.pendingSharedCartInit && !(restaurant.settings.sharedCart ?? false)) {
        // Individual cart mode (no action needed)
        this.pendingSharedCartInit = null  // Clear pending initialization
      }

      this.loadScript()
    }, 1000)
  }

  onProductUpdate = (querySnapshot: Object) => {
    const allProducts = []
    querySnapshot.forEach((doc) => {
      const { createdAt, ...data } = doc.data()
      allProducts.push({ id: doc.id, ...data });
    });
    this.allProducts = allProducts
    this.products = this.filterProducts(allProducts)
    this.getSections()
  }

  /**
   * Visibilité d'un produit : affichage sur place (display.eatin / displayApp) puis disponibilité
   * horaire (créneaux midi/soir par jour, jours fériés) — même filtre que we-kiosk-order.
   */
  filterProducts = (list: Array<Object>) => {
    const isPublicHoliday = isPublicHolidayToday()
    const period = getAvailabilityPeriod(this.availabilityHours, dayjs().day(), isPublicHoliday)
    return list.filter((p) =>
      ((p.display?.eatin === true) || (p.display?.eatin === undefined && (p.displayApp || p.displayApp === undefined)))
      && isProductAvailable(p, period, isPublicHoliday)
    )
  }

  // Re-filtre les produits quand on change de jour ou de service (midi/soir) ;
  // court-circuite tant qu'aucune frontière n'a été franchie.
  checkProductWithAvailability = () => {
    if (this.allProducts.length === 0) return
    const isPublicHoliday = isPublicHolidayToday()
    const { isDayTime, serviceDay } = getAvailabilityPeriod(this.availabilityHours, dayjs().day(), isPublicHoliday)
    const key = `${isPublicHoliday ? 1 : 0}|${serviceDay}|${isDayTime ? 1 : 0}`
    if (key === this._lastAvailabilityKey) return
    this._lastAvailabilityKey = key
    this.products = this.filterProducts(this.allProducts)
    this.getSections()
  }

  onCategoryUpdate = (querySnapshot: Object) => {
    const categories = []
    querySnapshot.forEach((doc) => {
      const { createdAt, ...data } = doc.data()
      if (!data.internal && (data.displayApp || data.displayApp === undefined)) categories.push({ id: doc.id, ...data })
    })
    this.categories = categories.sort((a, b) => (a.index < b.index ? -1 : 1))
    this.getSections()
  }


  toggleModal = (product) => () => {
    if (product.canOrder)
      this.setState(prevState => ({
        selectedProduct: { ...product },
        showProductDetail: !prevState.showProductDetail,
        selectedIdx: undefined
      }))
  }

  closeProductModal = () => {

    this.setState({ showProductDetail: false })
  }

  getSections = () => {
    const sections = []
    for (let i = 0; i < this.categories.length; i++) {
      const products = this.products.filter((item) => item.categoryId === this.categories[i].id).sort(((a, b) => (a.index < b.index ? -1 : 1)))
      if (products.length === 0) {
        this.categories[i].displayApp = false
        continue
      }
      sections.push({
        title: this.categories[i].name,
        description: this.categories[i].description,
        categoryMaxQuantity: this.categories[i].maxQuantity || 0,
        data: products,
        index: i,
        id: this.categories[i].id,
        category: this.categories[i]
      })
    }
    this.setState({ sections })
  }


  onClickCartProduct = (index) => e => {
    this.setState({
      selectedProduct: this.props.cart.products[index],
      showProductDetail: true,
      selectedIdx: index

    });
  };

  getOrderTotal = () => {
    let total = this.props.cart.total;
    if (this.props.cart.coupon !== null) {
      if (this.props.cart.coupon?.discountType === 'percent') {
        total = Number.parseFloat(computeDiscount(total, this.props.cart.coupon.discountPercent, true).toFixed(2));
      }
      else if (this.props.cart.coupon?.discountType === 'price') {
        total -= this.props.cart.coupon.discountPrice;
      }
    }
    return total;
  }

  closeCartModal = () => {
    this.setState({ showCart: false })
  }

  render() {
    const { t } = this.props
    const lang = this.props.settings.lang || DEFAULT_LANG
    const activeLanguages = getActiveLanguages(this.props.settings)
    if (this.state.invalidQrCode) {
      const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData404.default,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      }
      return (
        <div id="not-found">
          <Breakpoint medium up>
            <Lottie
              options={defaultOptions}
            />
          </Breakpoint>
          <Breakpoint small down>
            <Lottie
              options={defaultOptions}
            />
          </Breakpoint>
        </div>
      )
    }
    if (!this.state.informations) {
      const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData.default,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      }

      return (
        <div className="center-loading">
          <Breakpoint medium up>
            <Lottie
              options={defaultOptions}
            />
          </Breakpoint>
          <Breakpoint small down>
            <Lottie
              options={defaultOptions}
            />
          </Breakpoint>
        </div>
      )
    }

    return (
      <Container className="container" id="main-table">
        {
          this.props.settings.color && (
            <style> {`body {
              --website-color: ${this.props.settings.color}
            }`}
            </style>
          )
        }
        <div className="header">

          <div className="restaurant-info">
            <div className={`restaurant-title-row ${activeLanguages.length > 1 ? 'has-lang' : ''}`}>
              <div className="restaurant-name">
                {this.state.informations.name}
              </div>
              <LanguageSelector activeLanguages={activeLanguages} lang={lang} onChange={this.props.setLanguage} t={t} />
            </div>

            <div className="restaurant-info-table">
              <em><Trans i18nKey="restaurant.tableInfo" values={{ table: this.state.table }} components={{ b: <b /> }} /></em>
            </div>
          </div>
        </div>

        <div className="category-container" id="sticky-header">

          <div className="options">
            {this.categories.map((category, idx) =>
              <CategoryRow
                category={category}
                key={category.id}
                idx={idx}
                selected={idx === this.state.selectedCategoryIdx}
                selectCategory={this.selectCategory}
                lang={lang}
              />
            )}
          </div>
        </div>

        <Breakpoint medium up>
          <div className="product-grid">
            <div className="product-container">
              {this.state.sections.map((section, index) => (
                <div key={index}>
                  <Section title={getTrans(section.category, 'name', lang) || section.title} id={section.id} description={getTrans(section.category, 'description', lang)} />
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-4 justify-items-center">
                    {section.data.map((product) =>
                      <ProductRow
                        cartProducts={this.props.cart.products}
                        product={product}
                        key={product.id}
                        toggleModal={this.toggleModal}
                        orderType={this.props.cart.orderType}
                        settings={this.props.settings}
                        cdnDomain={this.cdnDomain}
                        lang={lang}
                        t={t}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
            {/* Desktop cart sidebar */}
            <div className="cart">
              <div className="cart-title rounded-lg">{t('modalCart.title')}</div>
              {this.state.canOrder === true && (
                <div className="cart-content">
                  {this.props.cart.products.map((product, index) =>
                    <ProductCartRow
                      product={product}
                      key={index}
                      index={index}
                      onClick={this.onClickCartProduct}
                    />
                  )}
                </div>
              )}

              {!this.state.canOrder ? (
                <div><em>{t('restaurant.orderSuspended')}</em></div>
              ) : this.props.cart.products.length === 0 ? (
                <div><em>{t('restaurant.emptyOrder')}</em></div>
              ) : (
                <div className="cart-bottom">
                  {this.props.cart.discount > 0 && (
                    <div className="cart-product-item discount-row">
                      <div className="cart-product-row" style={{ cursor: 'unset' }}>
                        <div>{t('restaurant.subtotal')}</div>
                        <div>{formatCurrency(this.props.cart.subtotal, this.props.settings.currencySymbol)}</div>
                      </div>
                    </div>
                  )}

                  {this.props.cart.discount > 0 && this.props.cart.subtotal !== this.props.cart.total && (
                    <div className="cart-product-item discount-row">
                      <div className="cart-product-row" style={{ cursor: 'unset' }}>
                        <div>{t('restaurant.discountTable', { discount: this.props.cart.discount })}</div>
                        <div>-{formatCurrency(this.props.cart.subtotal - this.props.cart.total, this.props.settings.currencySymbol)}</div>
                      </div>
                    </div>
                  )}

                  {this.props.cart.coupon !== null && this.props.cart.coupon?.discountType === 'percent' && (
                    <div className="cart-product-item discount-row">
                      <div className={`cart-row`} style={{ width: '100%', justifyContent: 'space-between' }}>
                        <div>{t('restaurant.couponPercent', { percent: this.props.cart.coupon.discountPercent })}</div>
                        <div>-{formatCurrency(computeDiscount(this.props.cart.total, this.props.cart.coupon.discountPercent, false), this.props.settings.currencySymbol)}</div>
                      </div>
                    </div>
                  )}

                  <div className="footer-desktop" onClick={() => this.setState({ showCart: true })}>
                    <div className="confirm-btn rounded-lg">
                      <span>{this.props.cart.totalProducts}</span>
                      <span>{t('modalCart.title')}</span>
                      <span>{formatCurrency(this.getOrderTotal(), this.props.settings.currencySymbol)}</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Breakpoint>

        <Breakpoint small down>
          <div className="product-grid">
            <div className="product-container">
              {this.state.sections.map((section, index) => (
                <div className="section-container" key={index}>
                  <Section title={getTrans(section.category, 'name', lang) || section.title} id={section.id} description={getTrans(section.category, 'description', lang)} />
                  <div className="grid grid-cols-2 gap-3 p-2 justify-items-center">
                    {section.data.map((product) =>
                      <ProductRow
                        cartProducts={this.props.cart.products}
                        product={product}
                        key={product.id}
                        toggleModal={this.toggleModal}
                        orderType={this.props.cart.orderType}
                        settings={this.props.settings}
                        cdnDomain={this.cdnDomain}
                        lang={lang}
                        t={t}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

        </Breakpoint>


        {this.readOnly === false && this.state.canOrder && this.props.cart.products.length > 0 && (
          <button className="logo logo-basket" onClick={() => this.setState({ showCart: true })}>
            <div className="footer">
              <div className="confirm-btn rounded-lg">
                <span>{this.props.cart.totalProducts}</span>
                <span>{t('modalCart.title')}</span>
                <span>{formatCurrency(this.props.cart.total, this.props.settings.currencySymbol)}</span>
              </div>
            </div>
          </button>
        )}

        <Modal
          show={this.state.showProductDetail}
          className="custom-map-modal"
          onHide={this.closeProductModal}
          size="md"
        >
          <ProductDetail
            cart={this.props.cart}
            product={this.state.selectedProduct}
            closeModal={this.closeProductModal}
            updateIndex={this.state.selectedIdx}
            options={this.options}
            readOnly={this.readOnly}
            canOrder={this.state.canOrder}
            cdnDomain={this.cdnDomain}
          />
        </Modal>

        <Modal
          show={this.state.showCart}
          className="custom-map-modal"
          onHide={this.closeCartModal}
          size="md"
        >
          <CartTable
            cart={this.props.cart}
            closeModal={this.closeCartModal}
            options={this.options}
            readOnly={this.readOnly}
            canOrder={this.state.canOrder}
            isModal={true}
          />

        </Modal>

      </Container >
    )
  }
}

// redux

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    settings: state.settings,
    colors: state.colors,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRestoInfo: (a, b, c, d, e, f) => dispatch(updateRestoInfo(a, b, c, d, e, f)),
    updateRestoSettings: (a, b, c, d, e, f, g, h, i, j) => dispatch(updateRestoSettings(a, b, c, d, e, f, g, h, i, j)),
    updateMenuSettings: (s) => dispatch(updateMenuSettings(s)),
    updateType: (type) => dispatch(updateType(type)),
    applyDiscount: (d) => dispatch(applyDiscount(d)),
    updateOrderSchedule: (schedule) => dispatch(updateOrderSchedule(schedule)),
    updateDeliverySchedule: (schedule) => dispatch(updateDeliverySchedule(schedule)),
    updateDeliverySettings: (s) => dispatch(updateDeliverySettings(s)),
    updateTakeawaySettings: (s) => dispatch(updateTakeawaySettings(s)),
    resetCart: () => dispatch(resetCart()),
    applyCoupon: (coupon) => dispatch(applyCoupon(coupon)),
    pickedOrderType: () => dispatch(pickedOrderType()),
    updateTable: (table) => dispatch(updateTable(table)),
    updateQrId: (qrId) => dispatch(updateQrId(qrId)),
    initSharedSession: (sessionId, sessionData) => dispatch(initSharedSession(sessionId, sessionData)),
    syncSharedCart: (cartData) => dispatch(syncSharedCart(cartData)),
    updateCartTotal: (cartTotal, cartTotalHT, cartTotalVat, cartTotalProducts, cartSubtotal) => dispatch(updateCartTotal(cartTotal, cartTotalHT, cartTotalVat, cartTotalProducts, cartSubtotal)),
    leaveSharedSession: () => dispatch(leaveSharedSession()),
    setLanguage: (lang) => dispatch(setLanguage(lang)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(RestaurantTable));
